import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the products api
 */
export class ProductService extends BaseService {

	constructor() {	
		super();
	}
	
	async getProducts(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/products' + params);		
		return data;		
	}
	
	async getProduct(productCode) {
		var data = await this.makeGETRequest('/api/resource/products/' + productCode);		
		return data;		
	}
	
	async getProductDetails(productCode) {
		var data = await this.makeGETRequest('/api/resource/products/' + productCode + '/detail');		
		return data;		
	}	
	
	async saveProduct(fullProduct, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/products/' + fullProduct.product.productCode, fullProduct);
		} else {
			saved = await this.makePOSTRequest('/api/resource/products', fullProduct);
		}
		return saved;		
	}	
	
	async updateProductStatus(productCode, active) {
		var data;
		if (active) {
			data = await this.makePUTRequest('/api/resource/products/' + productCode + '/activate');		
		} else {
			data = await this.makePUTRequest('/api/resource/products/' + productCode + '/inactivate');	
		}
		
		return data;		
	}
	
	async getEffectiveProductItems(productType) {
		var queryProductType  = '';
		if (productType) {
			queryProductType = '?productType=' + productType; 
		}
		var data = await this.makeGETRequest('/api/resource/product-items/effective' + queryProductType);		
		return data;		
	}	
	
}
